import { SessionType } from '@shared';

export function getStepActionVerb(stepStatus: PolicyApplicationStep['status'] | undefined): string {
  switch (stepStatus) {
    case 'completed':
      return 'Edit';
    case 'in_progress':
      return 'Resume';
    default:
      return 'Start';
  }
}

export function shouldRenderClientPreApplicationConsent(
  sessionType: SessionType,
  currentStepType: PolicyApplicationStep['stepType'] | undefined,
  currentStepStatus: PolicyApplicationStep['status'] | undefined,
): boolean {
  return (
    sessionType === SessionType.client &&
    currentStepType === 'preapplication-consent-form' &&
    currentStepStatus !== 'blocked'
  );
}
